import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { ref, onValue } from "firebase/database";
import { db } from "../firebase/config";
import styled from "styled-components";
import VehicleHeader from "./VehicleHeader";
import VehicleImageSlider from "./VehicleImageSlider";
import VehicleSpecs from "./VehicleSpecs";
import VehicleDescription from "./VehicleDescription";
import SimilarVehicle from "./SimilarVehicle";

const Spinner = styled.div`
  border: 8px solid #f3f3f3;
  border-top: 6px solid #e61717; /* Customize color */
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 0 auto;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;


const LoadingWrapper = styled.div`
  grid-column: 1 / -1;
  text-align: center;
  font-size: 30px;
  color: #555;
  padding: 100px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;


const Container = styled.div`
  padding: 40px;

  max-width: 90%;
  padding-top:25px;
  margin: auto;

  @media (max-width: 768px) {
    padding: 0px;
  }

`;


const VehicleDetails = () => {
  const { id } = useParams<{ id: string }>();
  const [vehicle, setVehicle] = useState<any | null>(null);

  useEffect(() => {
    const vehicleRef = ref(db, `vehicles/${id}`);
    onValue(vehicleRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const carImages = Object.values(data.carImages || {});
        setVehicle({ id, ...data, carImages });
      }
    });
  }, [id]);

  if (!vehicle) return   <LoadingWrapper>
  <Spinner />
  Loading...
</LoadingWrapper>;

  return (
    <Container>
      <VehicleHeader vehicle={vehicle} />

        <div >
      <VehicleImageSlider vehicle={vehicle} /></div>
<div></div>

      <VehicleSpecs vehicle={vehicle} />
      <VehicleDescription vehicle={vehicle} />
      <SimilarVehicle id={id}/>
    </Container>
  );
};

export default VehicleDetails;
